/**
 * Hero Section Component
 * Complete hero section with carousel and stock bar
 */
import HeroCarousel from './HeroCarousel';
import StockBar from '../StockBar';
import { navigateToSection } from '../../utils/navigation';

const HeroSection = ({
  games,
  currentGameIndex,
  setCurrentGameIndex,
  carouselRef,
  handleScroll,
  setHasSelectedGame,
  fadeToSlide,
  isMobile,
  shineDisabled,
  setShineDisabled,
}) => {
  return (
    <div
      id="home-container"
      className="relative -mt-[135px] h-[70vh] min-h-[500px] overflow-hidden"
    >
      <HeroCarousel
        games={games}
        carouselRef={carouselRef}
        handleScroll={handleScroll}
        setHasSelectedGame={setHasSelectedGame}
        currentGameIndex={currentGameIndex}
        setCurrentGameIndex={setCurrentGameIndex}
        isMobile={isMobile}
        shineDisabled={shineDisabled}
        setShineDisabled={setShineDisabled}
      />

      <StockBar
        name={games[currentGameIndex]?.name}
        packsInStore={games[currentGameIndex]?.packsInStore}
        games={games}
        currentGame={currentGameIndex}
        onSelect={fadeToSlide}
        onSelectButton={navigateToSection}
      />
    </div>
  );
};

export default HeroSection;
